import type { Coordinates } from '@shared/types/google-maps';
import type { HotelContent } from '@shared/types/hotel-content';

export const getHotelCoordinates = (uBFFHotel: HotelContent) => {
  if (!uBFFHotel.location || !uBFFHotel.location.coordinates) {
    return { latitude: null, longitude: null };
  }

  const { latitude, longitude } = uBFFHotel.location.coordinates;
  return { latitude, longitude };
};

export const getBounds = (coordinates: Coordinates[]) => {
  const lats = coordinates.map((item) => item.latitude).sort((a, b) => a - b);
  const lons = coordinates.map((item) => item.longitude).sort((a, b) => a - b);
  const bounds = {
    south: lats[0],
    west: lons[0],
    north: lats[lats.length - 1],
    east: lons[lons.length - 1],
  };
  return bounds;
};
